import { Card, CardContent } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { MessageSquare, User } from "lucide-react";
import { MESSAGE_TEMPLATES } from "../../utils/customMessageEmailGenerator";

export const MessageForm = ({ register, setValue, watch }) => (
  <>
    {/* Message Templates */}
    <Card className="border-2 border-pink-500 bg-pink-50">
      <div className="bg-pink-500 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          <MessageSquare className="h-4 w-4" />
          Quick Templates
        </h3>
      </div>
      <CardContent className="p-3">
        <div className="grid grid-cols-2 gap-2">
          {MESSAGE_TEMPLATES.map((template) => (
            <button
              key={template.id}
              type="button"
              onClick={() => {
                setValue('message_subject', template.subject);
                setValue('message_content', template.content);
                setValue('message_template_id', template.id);
              }}
              className={`p-2 rounded-lg text-left text-xs transition-all ${
                watch('message_template_id') === template.id
                  ? 'bg-pink-500 text-white'
                  : 'bg-white border border-pink-200 hover:border-pink-400'
              }`}
            >
              {template.name}
            </button>
          ))}
        </div>
      </CardContent>
    </Card>

    {/* Customer Details */}
    <Card className="border-2 border-slate-400">
      <div className="bg-slate-700 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          <User className="h-4 w-4" />
          Customer Details
        </h3>
      </div>
      <CardContent className="p-3 space-y-3">
        <div>
          <Label className="text-xs font-semibold">Customer Name</Label>
          <Input 
            {...register("message_customer_name")} 
            placeholder="e.g., John Smith"
            className="h-9 mt-1"
          />
        </div>
      </CardContent>
    </Card>

    {/* Email Subject */}
    <Card className="border-2 border-blue-400 bg-blue-50">
      <div className="bg-blue-500 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          ✉️ Email Subject
        </h3>
      </div>
      <CardContent className="p-3">
        <Input 
          {...register("message_subject")} 
          placeholder="Enter email subject..."
          className="h-10 font-medium"
        />
      </CardContent>
    </Card>

    {/* Message Content */}
    <Card className="border-2 border-emerald-400 bg-emerald-50">
      <div className="bg-emerald-500 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          📝 Message Content
        </h3>
      </div>
      <CardContent className="p-3">
        <Textarea 
          {...register("message_content")} 
          placeholder="Write your message here...

You can use multiple paragraphs.

Just press Enter twice for a new paragraph."
          className="min-h-[250px] text-sm leading-relaxed"
        />
        <p className="text-xs text-emerald-700 mt-2">
          Tip: Press Enter twice for new paragraphs. Your message will be formatted professionally in the email.
        </p>
      </CardContent>
    </Card>

    {/* Contact Footer Option */}
    <Card className="border-2 border-amber-300 bg-amber-50">
      <div className="bg-amber-500 px-3 py-2">
        <h3 className="font-bold text-black flex items-center gap-2 text-sm">
          📞 Contact Footer
        </h3>
      </div>
      <CardContent className="p-3 space-y-3">
        <div className="flex items-center gap-2">
          <input 
            type="checkbox" 
            {...register("message_include_contact")}
            defaultChecked={true}
            className="h-4 w-4 rounded border-gray-300"
          />
          <Label className="text-sm">Include "Call Us / Email Us" buttons</Label>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Label className="text-xs">Your Name</Label>
            <Input {...register("consultant_name")} placeholder="Sunny" className="h-8 mt-1 text-sm" />
          </div>
          <div>
            <Label className="text-xs">Your Title</Label>
            <Input {...register("consultant_title")} placeholder="Moving Consultant" className="h-8 mt-1 text-sm" />
          </div>
        </div>
      </CardContent>
    </Card>
  </>
);
